/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_AboutInputs */

const en_nav_about = /** @type {(inputs: Nav_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`About`)
};

const tr_nav_about = /** @type {(inputs: Nav_AboutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hakkımda`)
};

/**
* | output |
* | --- |
* | "About" |
*
* @param {Nav_AboutInputs} inputs
* @param {{ locale?: "en" | "tr" }} options
* @returns {LocalizedString}
*/
export const nav_about = /** @type {((inputs?: Nav_AboutInputs, options?: { locale?: "en" | "tr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_AboutInputs, { locale?: "en" | "tr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_about(inputs)
	return tr_nav_about(inputs)
});